module.exports = __webpack_public_path__ + "static/assets/142956eadc4328c71e8c975f73b1601b.png";